<template>
  <div class="container">
    <news-info
      api="Department_Info"
      :params="params"
      titleField="name"
      authorField="principalHisUserName"
      descField="introduction"
      dateField="address"
      contentField="detailIntroduction"
    />
  </div>
</template>

<script>
import NewsInfo from "@/components/NewsInfo";

export default {
  components: {
    NewsInfo
  },
  data() {
    return {
      params: {}
    };
  },
  created() {
    this.params = this.$route.query;
  },
  methods: {}
};
</script>
